import placeholder from '@/packages/components/base/svga/src/assets/img/placeholder.svga'

/**
 * 组件信息
 */
export const info = {
  name: 'xy-svga', // 组件名
  type: 'component-base', // 组件类型
  label: 'SVGA图片', // 组件label
  icon: 'icon-xy-svga', // 组件图标
  defaultWidth: 750, // 组件默认宽度
  defaultHeight: 400 // 组件默认宽度
}

/**
 * 组件默认参数
 */
export const defaultProps = {
  src: { type: String, default: placeholder },
  contentMode: { type: String, default: 'AspectFit' }
}

/**
 * 组件属性编辑表单信息
 */
export const editer = [
  {
    type: 'xy-form-upload-image', // 表单组件
    label: 'SVGA图片', // 表单名称
    propKey: 'src', // 表单model字段名称
    isLanguage: true, // 是否可多语言配置
    isActivityData: true, // 是否为动态数据
    accept: '.svga'
  },
  {
    type: 'xy-form-select', // 表单组件
    label: '拉伸模式', // 表单名称
    propKey: 'contentMode', // 表单model字段名称
    options: [
      {
        label: '铺满',
        value: 'Fill'
      },
      {
        label: '比例缩放',
        value: 'AspectFill'
      },
      {
        label: '自适应',
        value: 'AspectFit'
      }
    ]
  }
]
